import { Route, Routes } from "react-router-dom";
import List from "./list";
import View from "./view";
import Edit from "./view/edit";

export default function Course() {
  return (
    <Routes>
      <Route path="/" element={<List />} />
      <Route path="/:id" element={<View />} />
      <Route path="/:id/edit" element={<Edit />} />
    </Routes>
  );
}
